/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
export const GET_CURRENT_DISPLAY_OBJ_DRUG = 'GET_CURRENT_DISPLAY_OBJ_DRUG';
export const GET_ERROR_MSG_CMS_DRUG = 'GET_ERROR_MSG_CMS_DRUG';
export const GET_FROM_CMS_DRUG = 'GET_FROM_CMS_DRUG';
export const GET_QUARTERLY_CMS_DRUG_DATA = 'GET_QUARTERLY_CMS_DRUG_DATA';
export const SET_REFRESH_DATA_DRUG = 'SET_REFRESH_DATA_DRUG';
export const REFRESH_DATA_DRUG_DISPLAY = 'REFRESH_DATA_DRUG_DISPLAY';
